import React from "react"

const MedicalHistoryContext = React.createContext({})

const { Provider, Consumer } = MedicalHistoryContext

export { Provider, Consumer, MedicalHistoryContext }
